import * as React from "react";
const SVGComponent = ({ color = "#1D1D1D", ...props }) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx={10.3335}
      cy={10}
      r={9}
      fill="white"
      stroke={color}
      strokeWidth={2}
    />
    <g opacity={0.7}>
      <path
        d="M16.6904 7.77051C14.9074 5.98742 12.5347 5 9.99996 5C7.46524 5 5.09262 5.98736 3.30947 7.77051C2.89684 8.18314 2.89684 8.83156 3.30947 9.24419C3.51578 9.4505 3.7811 9.55371 4.04631 9.55371C4.31152 9.55371 4.57683 9.4505 4.78315 9.24419C6.16832 7.84412 8.02523 7.07778 9.99996 7.07778C11.9747 7.07778 13.8315 7.84412 15.2168 9.24408C15.6294 9.65671 16.2778 9.65671 16.6904 9.24408C17.1032 8.83145 17.1032 8.16832 16.6904 7.77041V7.77051Z"
        fill={color}
      />
      <path
        d="M6.07998 10.5553C5.66735 10.9679 5.66735 11.6163 6.07998 12.029C6.28629 12.2353 6.55161 12.3385 6.81682 12.3385C7.08203 12.3385 7.34734 12.2353 7.55366 12.029C8.90944 10.6732 11.1052 10.6732 12.4463 12.0143C12.8442 12.4269 13.5073 12.4269 13.9199 12.0143C14.3326 11.6016 14.3326 10.9532 13.9199 10.5406C11.7536 8.38897 8.24628 8.38897 6.07998 10.5553Z"
        fill={color}
      />
      <path
        d="M11.6356 14.4609C11.6356 15.3562 10.9099 16.0819 10.0145 16.0819C9.11929 16.0819 8.39355 15.3562 8.39355 14.4609C8.39355 13.5656 9.11929 12.8398 10.0145 12.8398C10.9099 12.8398 11.6356 13.5656 11.6356 14.4609Z"
        fill={color}
      />
    </g>
  </svg>
);
export default SVGComponent;
